export default "__VITE_ASSET__DoxL4Vrk__"